'use client'

import { FanAnswerCard } from '../creator/FanAnswerCard'
import { IFanQna } from '@/api/interfaces/IFanQna'
import { useInfinitePagination } from './InfinitePagination'
import { FanQnaApi } from '@/api/fanqna'
import { WithT } from '@/locales/types'
import { EmptyCard } from '../EmptyCard'
import { ListFilter } from '../filter/ListFilter'
import { createT } from '@/locales/index'
import { AuthUser, useAuthStore } from '@/store/auth'

interface PaginatedQnaAnswersProps {
  user?: AuthUser
  questionId: number
  params: IFanQna.IAnswers
  initial?: IFanQna.IAnswerPaginateRO
}

export const PaginatedQnaAnswers = ({
  user,
  questionId,
  params,
  initial,
  translations,
}: WithT<PaginatedQnaAnswersProps>) => {
  const t = createT(translations)
  const authUser = useAuthStore()

  const orders = [
    { text: t('order-popular'), id: 'POPULAR' },
    { text: t('order-recent'), id: 'LATEST' },
  ]

  const { listBottom, rows, count } = useInfinitePagination<
    IFanQna.IAnswerRO,
    IFanQna.IAnswers
  >({
    id: 'fan-qna-answers-paginated-infinite',
    paginateFunc: (args) => FanQnaApi(authUser.accessToken).answers(args),
    params,
    initial,
  })

  return (
    <>
      <div className="flex justify-between items-center">
        <span className="text-body2 text-key font-bold">
          {t('fanqna-edit-creator-qustion-answer-count', { count: count })}
        </span>
        <ListFilter
          orders={orders}
          translations={translations}
          useSearchParam
        />
      </div>

      {count === 0 ? (
        <EmptyCard
          className="bg-inherit"
          text={t('fanqna-edit-creator-answer-default')}
          translations={translations}
        />
      ) : (
        <>
          <ul className="flex flex-col gap-3">
            {rows.map((item) => (
              <FanAnswerCard
                key={item.id}
                user={user}
                item={item}
                questionId={questionId}
                translations={translations}
              />
            ))}
          </ul>

          <div ref={listBottom} />
        </>
      )}
    </>
  )
}
